// =============================================================================
// VM Size Display (provider-agnostic)
// =============================================================================
/** Generic VM size display info. For provider-specific details (exact specs, price),
 *  use the provider catalog API (GET /api/providers/catalog). */
export const VM_SIZE_LABELS = {
    small: { label: 'Small', shortDescription: '2-3 vCPUs, 4 GB RAM' },
    medium: { label: 'Medium', shortDescription: '4 vCPUs, 8-12 GB RAM' },
    large: { label: 'Large', shortDescription: '8 vCPUs, 16-32 GB RAM' },
};
// =============================================================================
// VM Size → vCPU Count Mapping (per provider)
// =============================================================================
/** vCPU counts per VM size, keyed by cloud provider.
 *  Providers have different hardware for the same abstract size. */
export const PROVIDER_VM_SIZE_VCPUS = {
    hetzner: { small: 2, medium: 4, large: 8 },
    scaleway: { small: 3, medium: 4, large: 8 },
    gcp: { small: 1, medium: 2, large: 4 },
};
/** Default vCPU counts when provider is unknown. Uses Hetzner as the reference. */
export const DEFAULT_VM_SIZE_VCPUS = {
    small: 2,
    medium: 4,
    large: 8,
};
/** Fallback vCPU count when both provider map and default size map miss. */
const VCPU_COUNT_UNKNOWN_FALLBACK = 2;
function isKnownVmSize(vmSize) {
    return Boolean(vmSize && Object.hasOwn(DEFAULT_VM_SIZE_VCPUS, vmSize));
}
/** Resolve the vCPU count for a given VM size and optional cloud provider. */
export function getVcpuCount(vmSize, cloudProvider) {
    const size = vmSize;
    if (cloudProvider) {
        const providerMap = PROVIDER_VM_SIZE_VCPUS[cloudProvider];
        if (providerMap) {
            return providerMap[size] ?? DEFAULT_VM_SIZE_VCPUS[size] ?? VCPU_COUNT_UNKNOWN_FALLBACK;
        }
    }
    return DEFAULT_VM_SIZE_VCPUS[size] ?? VCPU_COUNT_UNKNOWN_FALLBACK;
}
/** Return true when a node size has at least the requested abstract capacity. */
export function canSatisfyVmSize(candidateSize, requestedSize) {
    if (!requestedSize)
        return true;
    if (!isKnownVmSize(requestedSize))
        return true;
    if (!isKnownVmSize(candidateSize))
        return false;
    return DEFAULT_VM_SIZE_VCPUS[candidateSize] >= DEFAULT_VM_SIZE_VCPUS[requestedSize];
}
//# sourceMappingURL=vm-sizes.js.map